import { ISpecification, ISpecificationType } from "app/services/specification";
import { IList } from "app/shared";

export interface SpecificationStore {
    specification: ISpecification;
    specifications: IList<ISpecification[]>;
    specificationTypes: IList<ISpecificationType[]>;
}

export const SET_SPECIFICATIONS = 'SET_SPECIFICATIONS';
export const SET_SPECIFICATION = 'SET_SPECIFICATION';
export const SET_SPECIFICATION_TYPES = 'SET_SPECIFICATION_TYPES';

interface SetSpecifications {
    type: typeof SET_SPECIFICATIONS;
    specifications: IList<ISpecification[]>;
}

interface SetSpecificationTypes {
    type: typeof SET_SPECIFICATION_TYPES;
    specificationTypes: IList<ISpecificationType[]>;
}

interface SetSpecification {
    type: typeof SET_SPECIFICATION;
    specification: ISpecification;
}

export type SpecificationActionTypes = SetSpecifications | SetSpecificationTypes | SetSpecification;